import React from "react";
import { Button, Modal } from "antd";
import { gql, useMutation } from "@apollo/client";

const CINFIRMUSER = gql`
  mutation confirmUser($id: ID!, $confirmUserInput: ConfirmInput!) {
    confirmUser(id: $id, confirmInput: $confirmUserInput)
  }
`;
function ConfirmProfile({ id, disabled, children, onUpdateUser }) {
  const [runConfirmUser, confirmUser] = useMutation(CINFIRMUSER, {
    onCompleted(data) {
      Modal.success({
        title: "عملیات موفق",
        content: `پروفایل کاربر تایید شد.`,
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
        onOk: onUpdateUser()
      });
    },
    onError(err) {
      console.log("خطا: " + err.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
  });

  const doConfirmUser = () => {
    const confirmUserInput = {
      confirmMessage: "پروفایل شما تایید شد",
      confirmStatus: "SUCCESS",
    };
    runConfirmUser({
      variables: { id, confirmUserInput },
    });

  };
  return (
    <div>
      <Button
        onClick={doConfirmUser}
        loading={confirmUser.loading && true}
        type="primary"
        disabled={disabled}
      >
        {children}
      </Button>
    </div>
  );
}

export default ConfirmProfile;
